
import type { CSSProperties } from "react";
import type { NodeShape } from "@/utils/shapeUtils";

// Compute padding and alignment so text visually fits inside different shapes
export function getShapeTextFitStyle(shape: NodeShape, width: number, height: number): CSSProperties {
  const w = Math.max(0, width || 0);
  const h = Math.max(0, height || 0);

  switch (shape) {
    case "circle": {
      // Leave margins so text doesn't touch curved edges
      const px = Math.max(w * 0.22, 12);
      const py = Math.max(h * 0.18, 10);
      return {
        paddingLeft: px,
        paddingRight: px,
        paddingTop: py,
        paddingBottom: py,
        textAlign: "center",
      };
    }
    case "diamond": {
      // Diamond has narrow corners; increase horizontal padding
      const px = Math.max(w * 0.28, 14);
      const py = Math.max(h * 0.20, 10);
      return {
        paddingLeft: px,
        paddingRight: px,
        paddingTop: py,
        paddingBottom: py,
        textAlign: "center",
      };
    }
    case "pentagon": {
      // More top padding due to top apex
      const px = Math.max(w * 0.18, 12);
      const pt = Math.max(h * 0.24, 14);
      const pb = Math.max(h * 0.14, 10);
      return {
        paddingLeft: px,
        paddingRight: px,
        paddingTop: pt,
        paddingBottom: pb,
      };
    }
    case "cloud": {
      // Softer padding all around
      const px = Math.max(w * 0.16, 12);
      const py = Math.max(h * 0.16, 12);
      return {
        paddingLeft: px,
        paddingRight: px,
        paddingTop: py,
        paddingBottom: py,
      };
    }
    case "rectangle":
    default: {
      // Minimal default padding; classes may add small base spacing
      return {
        padding: 12,
      };
    }
  }
}
